export const FRONTEND_BUILD_MESSAGES = [
  "Sketching the first screen layout.",
  "Arranging the hero section and primary actions.",
  "Mapping page-to-page navigation paths.",
  "Assembling a clean component hierarchy.",
  "Wiring the main interaction flow.",
  "Drafting responsive breakpoints for smaller screens.",
  "Balancing spacing across the primary layout.",
  "Composing reusable cards and panels.",
  "Aligning typography for readability.",
  "Shaping the shell for the first route.",
  "Connecting buttons to their core actions.",
  "Building a clear visual hierarchy.",
  "Placing navigation where it feels natural.",
  "Creating the opening experience for first-time users.",
  "Refining the app frame for desktop view.",
  "Adapting the interface for mobile viewports.",
  "Stitching together the first working screen.",
  "Laying out content blocks for fast scanning.",
  "Defining the structure for reusable sections.",
  "Preparing state for the main UI flow.",
  "Organizing sections into a predictable pattern.",
  "Building the first pass of the page header.",
  "Designing the primary content region.",
  "Fitting actions into the right context.",
  "Making room for the main conversion path.",
  "Composing the initial landing state.",
  "Setting up the base visual rhythm.",
  "Aligning containers to the viewport grid.",
  "Building supporting interface sections.",
  "Filling out the first interactive route.",
  "Arranging actions for a smoother task flow.",
  "Laying out forms and input zones.",
  "Connecting UI states for the initial journey.",
  "Refining the arrangement of the working canvas.",
  "Preparing patterns for repeated content.",
  "Generating the base screen composition.",
  "Spacing interface elements for clarity.",
  "Adding structure to the first content stack.",
  "Building a stronger entry point for the app.",
  "Creating the first usable navigation frame.",
  "Wiring essential frontend behaviors.",
  "Preparing components for real interactions.",
  "Drafting the first interactive viewport.",
  "Constructing the main application shell.",
  "Lining up actions with user intent.",
  "Resolving the first-pass route structure.",
  "Connecting interface pieces into a usable flow.",
  "Arranging panels for better focus.",
  "Sharpening the first-screen composition.",
  "Creating a cleaner scan path through the UI.",
  "Structuring the layout for easier movement.",
  "Tuning alignment across key interface elements.",
  "Preparing the base styling system.",
  "Wiring basic navigation feedback states.",
  "Building the initial screen transitions.",
  "Preparing visible states for user actions.",
  "Composing a more coherent frontend skeleton.",
  "Shaping the application around the main task.",
  "Resolving content containers and layout stacks.",
  "Assembling the first polished surface.",
  "Creating stronger grouping for related actions.",
  "Aligning content with the core workflow.",
  "Building a stable first render path.",
  "Adding structure to the interaction layer.",
  "Preparing sections for real data later.",
  "Creating the first working presentation flow.",
  "Establishing a cleaner app foundation.",
  "Building a more intentional page rhythm.",
  "Connecting routes with the primary use case.",
  "Preparing the first pass of empty states.",
  "Laying down the first styled components.",
  "Composing the core frontend scaffold.",
  "Organizing the viewport around the main action.",
  "Balancing text blocks and interactive controls.",
  "Refining how content enters the page.",
  "Constructing the visible interaction loop.",
  "Placing primary actions where users expect them.",
  "Defining the app shell around the key journey.",
  "Creating a stronger foundation for page content.",
  "Arranging navigation and content into one flow.",
  "Connecting frontend states to the interface frame.",
  "Generating the first complete route experience.",
  "Preparing visual states for loading and transitions.",
  "Building a cleaner structure for the page body.",
  "Shaping containers around the main story of the app.",
  "Tightening the first-pass component spacing.",
  "Creating a more usable top-level layout.",
  "Extending the shell into working screens.",
  "Connecting the interface to the current plan.",
  "Building the first coherent frontend pass.",
  "Preparing high-priority sections first.",
  "Refining placement for supporting actions.",
  "Structuring the app to reduce visual clutter.",
  "Composing key interface blocks into one screen.",
  "Making the initial UI easier to navigate.",
  "Building the visual backbone of the application.",
  "Preparing containers for interactive content.",
  "Linking layout regions into a complete flow.",
  "Resolving the first route into a usable page.",
  "Drafting the interface around the main objective.",
  "Creating the first production-shaped screen.",
  "Arranging components for faster comprehension.",
  "Organizing layout decisions into a stable structure.",
  "Building the first interactive composition.",
  "Preparing the frontend for the live preview handoff.",
  "Refining the base layout before publish.",
  "Connecting the app shell to the rendered routes.",
  "Building the visible framework for user actions.",
  "Completing the first pass of the frontend canvas.",
  "Assembling the app around the primary journey.",
  "Resolving composition details before preview.",
  "Preparing the generated UI for first load.",
  "Polishing the first interface arrangement.",
  "Building out sections users will touch first.",
  "Creating a cleaner handoff into the preview.",
  "Finalizing the generated frontend surface.",
] as const;

export const getNextLoadingMessageIndex = (
  total: number,
  currentIndex: number,
) => {
  if (total <= 1) return 0;

  let nextIndex = Math.floor(Math.random() * total);

  while (nextIndex === currentIndex) {
    nextIndex = Math.floor(Math.random() * total);
  }

  return nextIndex;
};
